export default {
  ['title']: '参赛指南',
  ['label-deadline']: '投稿截止'
}
